/* eslint class-methods-use-this: "off" */
import { Controller } from '@hotwired/stimulus';

import('@material-tailwind/html/scripts/collapse');

export default class extends Controller {
  handleAccordionNameToggle = (event) => {
    const collapseButton = event.target;
    const isCollapsed = collapseButton.innerText === 'Pokaż mniej';

    collapseButton.innerText = isCollapsed ? 'Pokaż więcej' : 'Pokaż mniej';
  };

  disabledUpAndDownKeyboardsArrows = (event) => {
    const key = event.charCode || event.keyCode;
    // Disable Up and Down Arrows on Keyboard
    if (key === 38 || key === 40) {
      event.preventDefault();
    }
  };

  disableScroll = (event) => {
    event.preventDefault();
  };

  openZendeskPopup = () => {
    window.zE('messenger', 'open');
  };
}
